import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {APP} from "../../app/consts";
import {WIZARD_WIDGET} from "../../../widgets/wizard-widget/wizard-widget-consts";

export class WizardClickEvent extends ClickEvent {
  screen: APP.ANALYTICS.SOURCES;
  source: WIZARD_WIDGET.SOURCE.USER_DRIVEN;

  constructor(params) {
    super('', 'click', 'wizard');

    this.screen = params.screen;
    this.source = params.source;
  }

  get properties() {
    const properties = super.properties;

    properties.screen = this.screen;
    properties.source = this.source;

    return properties;
  }
}
